export default {
  updateStates(state, val) {
    state.states = val;
  },
  updateCities(state, val) {
    state.cities = val;
  },
  updateCounties(state, val) {
    state.counties = val;
  },
  updateRaces(state, val) {
    state.races = val;
  },
  updateGenders(state, val) {
    state.genders = val;
  },
  updateTestKit(state, val) {
    state.testkits = val;
  },
  updateHowHeard(state, val) {
    state.howheard = val;
  },
  updateClinic(state, val) {
    state.clinics = val;
  },
  updateMailingCity(state,val){
    state.mailingCities = val;
  },
  updateMailingState(state,val){
    state.mailingStates = val;
  },
  updateMailingCounties(state,val){
    state.mailingCounties = val;
  },
  updateSexWiths(state, val) {
    state.sexWiths = val;
  },
  updateSexAtBirth(state, val) {
    state.sexAtBirths = val;
  },
};
